import * as React from 'react';
import TopBar from '../../components/molecules/TopBar';
import * as _ from 'underscore';
import TopBarHomeButton from '../../components/atoms/TopBarHomeButton';
import Calendar, { CalendarTileProperties, ViewCallbackProperties } from 'react-calendar';
import { useNavigate } from 'react-router-dom';
import { SelfObservationDayDB } from '../../data/datatypes';
import { getSelfObservationDays } from '../../services/DBService/DbService';

const getSimpleDateString = (date: Date): string => {
    // clean timezone offset for toISOString
    const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return newDate.toISOString().substring(0, 10);
};

const getFirstDayOfCurrentMonth = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 1);
};

const SelfObservation = () => {
    const navigate = useNavigate();

    const [activeStartDate, setActiveStartDate] = React.useState<Date>(getFirstDayOfCurrentMonth());
    const [selfObservationDays, setSelfObservationDays] = React.useState<SelfObservationDayDB[]>();

    React.useEffect(() => {
        console.log('fetching data for all days...');
        const fetchData = async () => {
            const from = getSimpleDateString(activeStartDate);
            const to = from.substring(0, 8).padEnd(10, '31');
            setSelfObservationDays(await getSelfObservationDays(from, to));
        };
        setTimeout(() => fetchData(), 100); // to let the saving callback from previous views run first
    }, [activeStartDate]);

    const dayClicked = (value: Date, event: React.ChangeEvent<HTMLInputElement>) => {
        navigate(getSimpleDateString(value));
    };

    const getTileContent = (props: CalendarTileProperties) => {
        const dateString = getSimpleDateString(props.date);
        if (!selfObservationDays) {
            return <>
                <br />
                <div>&nbsp;</div>
            </>;
        }
        const dayData = selfObservationDays.find(day => day._id === `selfobservation_${dateString}`);
        if (!dayData || (!dayData.moodLevel && !dayData.activityLevel && !dayData.foodLevel)) {
            return <>
                <br />
                <div>&nbsp;</div>
            </>;
        }

        const dots: JSX.Element[] = [];
        dots.push(<span key="food" className="react-calendar__tile__custom-dot-green" />);
        return <>
            <br />
            <div>
                {dots}
            </div>
        </>;
    };

    const activeStartDateChanged = (props: ViewCallbackProperties) => {
        setActiveStartDate(props.activeStartDate);
    };

    return (
        <div className="content hunger">
            <TopBar
                title="Tagebuch"
                icon={'icon_protocol.svg'}
                leftButtons={[<TopBarHomeButton />]}
            />
            <div className="content-container">
            <h1 className="page-title">Wie geht es Dir heute?</h1>
                <p>
                    Tippe auf einen Tag, um die Fragen des Tages zu beantworten.
                </p>
                <Calendar
                    onChange={dayClicked}
                    onActiveStartDateChange={activeStartDateChanged}
                    tileContent={getTileContent}
                    maxDate={new Date()}
                    minDetail="month"
                    next2Label={null}
                    prev2Label={null}
                    showNeighboringMonth={false}
                />
            </div>
        </div>
    );
};

export default SelfObservation;